import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PageHome,PageNotFound,MemberSignupPage,PageDev} from './Pages';
const Router =() =>{
    return (
        <Routes>
            <Route path="/" element={<PageHome />} />
            <Route path="/Member/Signup" element={<MemberSignupPage />} />
            <Route path="/dev" element={<PageDev/>}/>
            <Route path="*" element={<PageNotFound/>} />
        </Routes>
    )
}

export default React.memo(Router)